import tw, { styled } from 'twin.macro';

const MarkdownHeading5 = styled.h3`
  ${tw`w-full py-2 text-base`}

  .message-type-markdown & {
    ${tw`py-0 border-b-0 m-0`}
  }
`;

export default MarkdownHeading5;
